<script setup lang="ts">
  import { TooltipProvider, TooltipRoot } from "radix-vue"
  import { computed, ref } from "vue"

  import TooltipContent from "./PlainTooltipContent.vue"
  import TooltipTrigger from "./PlainTooltipTrigger.vue"

  interface TooltipProps {
    defaultOpen?: boolean
    open?: boolean
  }

  const props = withDefaults(defineProps<TooltipProps>(), {
    defaultOpen: false,
    open: undefined,
  })

  const isInternalOpenRef = ref(false)

  const isTooltipOpen = computed(() => {
    return isInternalOpenRef.value || props.open
  })

  defineOptions({
    inheritAttrs: false,
  })
</script>

<template>
  <TooltipProvider>
    <TooltipRoot
      :delay-duration="400"
      :default-open="props.defaultOpen"
      :open="isTooltipOpen"
      :on-update:open="(e) => (isInternalOpenRef = e)"
      data-testid="plain-tooltip"
      disable-closing-trigger
    >
      <TooltipTrigger @click="isInternalOpenRef = !isInternalOpenRef">
        <slot name="trigger" />
      </TooltipTrigger>
      <TooltipContent>
        <slot />
      </TooltipContent>
    </TooltipRoot>
  </TooltipProvider>
</template>
